import { ChevronRight } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChevronRightIcon = createLucideIcon(ChevronRight);
